import React from 'react';

import PublicCourseListContainer from '@src/components/course/list/catalog/PublicCourseListContainer';

const PublicCourseListPage = () => <PublicCourseListContainer />;

export default PublicCourseListPage;
